<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 px-6 py-6">
      <div class="flex justify-between">
        <h6 class="text-primary text-xl font-bold w-6/12 text-start"> حساب کاربری </h6>
        <h6 class="text-primary text-lg w-6/12 text-end" >
           <i> <a routerLink="/doctor-panel/appointment"> بازگشت </a> </i></h6>
  
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <form>
        <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
          اطلاعات شخصی
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-xs font-bold my-4" htmlFor="grid-password"> جنسیت
                </label>
                <div class="flex items-center m-4">
                  <input id="inline-radio" type="radio" value="" name="inline-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio" class="mx-2 text-sm font-medium text-gray-900 "> آقا
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="inline-2-radio" type="radio" value="" name="inline-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-2-radio" class="mx-2 text-sm font-medium text-gray-900 "> خانم
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                نام
              </label>
              <input type="text"
                class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                نام خانوادگی
              </label>
              <input type="email"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
                شماره تلفن
              </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                کد ملی
              </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                سال تولد
              </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                نوع بیمه
              </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
        </div>
  
        <hr class="mt-6 border-b-1 border-blueGray-300" />
  
        <h6 class="text-blueGray-400 text-sm mt-3 mb-6 font-bold uppercase">
          پرونده بیمار
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <label class="uppercase text-blueGray-600 text-xs font-bold my-4" htmlFor="grid-password"> آیا بیماری زمینه
                ای دارید؟
              </label>
              <div class="flex">
                <div class="flex items-center m-2">
                  <input id="inline-radio1" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio1" class="mx-1 text-sm font-medium text-gray-900 "> مشکل خاصی
                    ندارم </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio2" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio2" class="mx-1 text-sm font-medium text-gray-900 "> دیابت
                  </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio3" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio3" class="mx-1 text-sm font-medium text-gray-900 "> کم کاری
                    تیروئید </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio4" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio4" class="mx-1 text-sm font-medium text-gray-900 "> پر کاری
                    تیروئید </label>
                </div>
              </div>
              <div class="flex">
                <div class="flex items-center m-2">
                  <input id="inline-radio5" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio5" class="mx-1 text-sm font-medium text-gray-900 "> فشار خون
                    بالا </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio6" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio6" class="mx-1 text-sm font-medium text-gray-900 "> فشار خون
                    پایین </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio7" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio7" class="mx-1 text-sm font-medium text-gray-900 "> چربی خون
                  </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio8" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio8" class="mx-1 text-sm font-medium text-gray-900 "> بیماری
                    روماتیسمی </label>
                </div>
              </div>
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-xs font-bold my-4" htmlFor="grid-password"> سابقه بیماری قلبی دارید؟
                </label>
                <div class="flex items-center m-4">
                  <input id="radio1" type="radio" value="true" name="heart-disease"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio1" class="mx-2 text-sm font-medium text-gray-900 "> بله
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="radio2" type="radio" name="heart-disease"
                   value="false" 
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio2" class="mx-2 text-sm font-medium text-gray-900 "> خیر
                  </label>
                </div>
              </div>
              <input type="text" disabled
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-xs font-bold my-4" htmlFor="grid-password"> سابقه بیماری ریوی دارید؟
                </label>
                <div class="flex items-center m-4">
                  <input id="radio3" type="radio" value="true" name="lung-disease" 
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio3" class="mx-2 text-sm font-medium text-gray-900 "> بله
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="radio4" type="radio" value="false" name="lung-disease" 
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300" checked>
                  <label for="radio4" class="mx-2 text-sm font-medium text-gray-900 "> خیر
                  </label>
                </div>
              </div>
              <input type="text" disabled
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                آیا بیماری دیگری دارید؟ (شرح دهید)
              </label>
              <textarea type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"
                rows="4">  </textarea>
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <label class="uppercase text-blueGray-600 text-xs font-bold my-4" htmlFor="grid-password"> آیا بیماری زمینه
                ای دارید؟
              </label>
              <div class="flex">
                <div class="flex items-center m-2">
                  <input id="inline-radio-1" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-1" class="mx-1 text-sm font-medium text-gray-900 ">  سابقه جراحی دارم  </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-2" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-2" class="mx-1 text-sm font-medium text-gray-900 "> جراحی قلب </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-3" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-3" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن کیسه صفرا </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-4" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-4" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن رحم  </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-5" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-5" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن روده </label>
                </div>
              </div>
            </div>
          </div>
  
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                آیا جراحی دیگری انجام داده اید؟
              </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                داروهای در حال مصرف           
               </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" htmlFor="grid-password">
                حساسیت ها           
               </label>
              <input type="text"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="flex justify-end w-full mb-3">
              <button type="button" class="bg-primary text-white active:bg-green-900 font-bold uppercase text-lg px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1">
                 تایید اطلاعات 
                </button>
            </div>
          </div>
  
        </div>
  
      </form>
    </div>
  </div>